import { useInteractAnywhere } from '../hooks/useInteractAnywhere';
import { useUiConfig } from '../providers/UiConfigProvider';
import { usePartialIframe } from './OverlayOverrides';
export const usePopoverIframe = (props)=>{
    var _props_targetRef_current;
    const uiConfig = useUiConfig();
    const getUILayers = uiConfig === null || uiConfig === void 0 ? void 0 : uiConfig._unstable_getUILayers;
    const handleClose = (event)=>{
        var _props_targetRef_current;
        if (props.onClose && event.target !== props.targetRef.current && !((_props_targetRef_current = props.targetRef.current) === null || _props_targetRef_current === void 0 ? void 0 : _props_targetRef_current.contains(event.target))) {
            props.onClose();
        }
    };
    useInteractAnywhere(handleClose, (_props_targetRef_current = props.targetRef.current) === null || _props_targetRef_current === void 0 ? void 0 : _props_targetRef_current.ownerDocument);
    return usePartialIframe({
        ...props,
        uiLayers: getUILayers ? getUILayers() : []
    });
};

//# sourceMappingURL=PopoverOverrides.js.map